<template>
    <div>
        <aside class="sidebar">
            <div class="wrapper site-header__wrapper">
                <router-link to="/">
                    <div class="logo">
                        <h1><img src="@/assets/tool-logo.png" /></h1>
                    </div>
                </router-link>
                <div class="sidebar-content">
                    <ul>
                        <router-link
                            :to="content.to"
                            v-for="content in sidecontents"
                            :key="content.index"
                        >
                            <li class="side-link">{{ content.title }}</li>
                        </router-link>
                    </ul>
                    <hr width="200">
                    <ul class="anotherul">
                        <a :href="content.to" target="_blank"
                            v-for="content in sideAnotherContents"
                            :key="content.index"
                        >
                            <li class="bl_media_item side-link">
                            {{ content.title }}
                            <span class="svg">
                                <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 12V6C5 5.44772 5.44772 5 6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H12M8.11111 12H12M12 12V15.8889M12 12L5 19" stroke="#212121" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                            </li>
                        </a>
                    </ul>
                </div>
                <router-link to="/rule">
                    <div class="ruleblock side-link">
                        <span class="rule">ご利用のルール</span>
                    </div>
                </router-link>
                <router-link to="/news">
                    <div class="ruleblock side-link">
                        <span class="rule">アプデ情報</span>
                    </div>
                </router-link>
                <a href="https://hari-stream.com/" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/mini-hari.png" alt="" class="side-banner" />
                </a>
                <a href="https://talk-boost.com/" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/mini-talkboost.png" alt="" class="side-banner" />
                </a>
            </div>
            <footer class="footer01">
                <div class="copyrow">
                    <p class="copyright">
                    &copy; ruri.info
                    </p>
                </div>
            </footer>
        </aside>
    </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return{
        sidecontents: [
            {
                index: 1,
                type: "internal",
                to: "/clockcreate",
                title: "デジタル時計",
            },
            {
                index: 2,
                type: "internal",
                to: "/ytcomment",
                title: "コメント欄用CSS",
            },
            {
                index: 3,
                type: "internal",
                to: "/discordroom",
                title: "DiscordオーバレイCSS",
            },
            {
                index: 4,
                type: "internal",
                to: "/timer",
                title: "タイマー",
            },
            {
                index: 5,
                type: "internal",
                to: "/counter",
                title: "デザインカウンター",
            },
            {
                index: 6,
                type: "internal",
                to: "/roulette",
                title: "ルーレット",
            },
            // {
            //     index: 5,
            //     type: "internal",
            //     to: "/timecounter",
            //     title: "年越しカウンター",
            // },
        ],
        sideAnotherContents: [
            {
                index: 2,
                type: "external",
                to: "https://www.ruri.info/",
                title: "ruri.info",
            },
        ],
    }
  }
}
</script>
<style scoped>
* {
    margin: 0;
}
.sidebar {
    display: none;
    width: 18rem;
    height: 100vh;
    top: 0;
    position: sticky;
    padding: 12px 6px 6px 6px;
    box-shadow: 4px 4px 8px rgb(0 0 0 / 2%);
    border: 1px solid rgba(255, 255, 255, 0.4);
}

.router-link-active li {
    background: linear-gradient(-225deg, #acb6e5 0%, #C5C1FF 56%, #FFBAC3 100%);
    opacity: 0.75;
    border-radius: 10px;
}

.side-link{
    background: transparent;
    transition: background 0.3s;
    border-radius: 10px;
}

.side-link:hover{
    /* background: linear-gradient(-225deg, #acb6e5 0%, #C5C1FF 56%, #FFBAC3 100%); */
    background-color: #C5C1FF;
    opacity: 0.75;
}

.premium-side-link{
    background: transparent;
    transition-duration: .3s;
    border-radius: 10px;
}

.premium-side-link:hover{
    /* background: linear-gradient(-225deg, #acb6e5 0%, #C5C1FF 56%, #FFBAC3 100%); */
    background-color: #C5C1FF;
    opacity: 0.75;
}

a{
    text-decoration: none;
    color: #212121;
    font-weight:  bold;
}

.anotherul{
    padding: 0.3rem 0.5rem 0.3rem 0.5rem;
    margin-top:0rem;
    margin-right:1rem;
    margin-left:32px;
}

li{
    list-style:none;
    color: #212121;
    font-weight:  bold;
    padding: 0.8rem 0.5rem 0.8rem 0.5rem;
    margin-right:1rem;
}


.svg svg{
    margin-left:1px;
    padding-top: 5px;
}

.logo h1 img{
    max-height: 30vh;
    height: auto;
    width: 100%;
}
.wrapper{
    margin-left: auto;
    margin-right: auto;
}

.ruleblock{
    padding: 0.8rem 0.5rem 0.8rem 0.5rem;
    margin-right:1rem;
    margin-left:38px;
}

.side-banner{
    margin-top:1.5rem;
    margin-right:1rem;
    margin-left:38px;
    border-radius: 0.375rem;
    transition-duration: .3s;
}

.side-banner:hover{
    transform: translateY(-2px);
    box-shadow: 0 7px 34px rgba(50,50,93,.1), 0 3px 6px rgb(0 0 0 / 5%);
    transition: all .5s;
}

hr {
    margin: auto;
    margin-top: 48px;
}

@media screen and (min-width: 768px){
    .sidebar{
        display: block;
    }
}

.footer01 {
  position: sticky;
  top: 100vh;

 color: #808080;
 padding-bottom: 30px;
 padding-left:48px;
}

.footer01 .copyrow{
  display: flex;
}

</style>